/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RoleDto } from '../models/role-dto';

@Injectable({
  providedIn: 'root',
})
export class UserRoleRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createOrUpdateUserRole
   */
  static readonly CreateOrUpdateUserRolePath = '/api/v1/userRoles/user/{userId}';

  /**
   * Adds UserRole passed to the method to User based on the given user Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateUserRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateUserRole$Response(params: {
    userId: string;
    body: RoleDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RoleDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserRoleRestControllerService.CreateOrUpdateUserRolePath, 'post');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoleDto>;
      })
    );
  }

  /**
   * Adds UserRole passed to the method to User based on the given user Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateUserRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateUserRole(params: {
    userId: string;
    body: RoleDto
  },
  context?: HttpContext

): Observable<RoleDto> {

    return this.createOrUpdateUserRole$Response(params,context).pipe(
      map((r: StrictHttpResponse<RoleDto>) => r.body as RoleDto)
    );
  }

  /**
   * Path part for operation getUserRoleById
   */
  static readonly GetUserRoleByIdPath = '/api/v1/userRoles/{id}';

  /**
   * Provides RoleDto based on given Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserRoleById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserRoleById$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RoleDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserRoleRestControllerService.GetUserRoleByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoleDto>;
      })
    );
  }

  /**
   * Provides RoleDto based on given Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserRoleById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserRoleById(params: {
    id: number;
  },
  context?: HttpContext

): Observable<RoleDto> {

    return this.getUserRoleById$Response(params,context).pipe(
      map((r: StrictHttpResponse<RoleDto>) => r.body as RoleDto)
    );
  }

  /**
   * Path part for operation getUserRoles
   */
  static readonly GetUserRolesPath = '/api/v1/userRoles/all';

  /**
   * Provides the list of all user role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserRoles$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<RoleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, UserRoleRestControllerService.GetUserRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoleDto>>;
      })
    );
  }

  /**
   * Provides the list of all user role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserRoles(params?: {
  },
  context?: HttpContext

): Observable<Array<RoleDto>> {

    return this.getUserRoles$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<RoleDto>>) => r.body as Array<RoleDto>)
    );
  }

}
